import { useCallback } from 'react';
import { InputFieldType, measureEquals, NullableMeasure } from '@e2m-customer-portal/shared';
import { Deadline, isAfterDeadline } from '../../utils';
import { Field } from '../use-input-field-rules/use-input-field-rules';

export function useInputFieldDisable(
  fields: readonly Field[],
  deadlines: readonly Deadline[],
  installedPower: NullableMeasure,
  limits: readonly { type: InputFieldType; isDisabled?: boolean }[],
  date: Date | number,
): (type: InputFieldType) => boolean {
  return useCallback(
    (t: InputFieldType) => {
      const limit = limits.find((f) => f.type === t);
      if (limit?.isDisabled) {
        return true;
      }

      const deadline = deadlines.find((d) => d.type === t)?.deadline;
      if (deadline && isAfterDeadline(deadline, date)) {
        return true;
      }

      if (t === InputFieldType.FCR) {
        const prodField = fields.find((f) => f.type === InputFieldType.PRODUCTION);
        if (prodField && (prodField.value.value === 0 || measureEquals(prodField.value, installedPower))) {
          return true;
        }
      }

      return false;
    },
    [fields, deadlines, installedPower, limits, date],
  );
}
